"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ZBParser = _interopRequireDefault(require("@/components/FormGenerator/components/parser/ZBParser"));
var _systemConfig = require("@/api/systemConfig.js");
var _marketing = require("@/api/marketing");
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'SeckillConfig',
  components: {
    zbParser: _ZBParser.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      isShow: true,
      isCreate: 0,
      editData: {},
      formId: 123,
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        name: '',
        isDel: false,
        status: ''
      },
      seckillId: '',
      loading: false
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this = this;
      this.$modalSure().then(function () {
        (0, _marketing.seckillDeleteApi)({
          id: id
        }).then(function () {
          _this.$message.success('删除成功');
          if (_this.tableData.data.length === 1 && _this.tableFrom.page > 1) _this.tableFrom.page = _this.tableFrom.page - 1;
          _this.getList();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this2 = this;
      (0, _marketing.seckillConfigStatusApi)(row.id, {
        status: row.status
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.$message.success('修改成功');
              _this2.getList();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))).catch(function () {
        row.status = !row.status;
      });
    },
    onEditSort: function onEditSort(row) {
      this.$set(row, 'isEdit', true);
    },
    onBlur: function onBlur(row) {
      this.$set(row, 'isEdit', false);
      this.onEdit(row.id, row);
    },
    // 获取表单详情
    getFormInfo: function getFormInfo(id) {
      var _this3 = this;
      this.loading = true;
      (0, _marketing.seckillInfoApi)({
        id: id
      }).then(function (res) {
        _this3.editData = res;
        _this3.dialogVisible = true;
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    // 编辑
    handleEdit: function handleEdit(id) {
      this.seckillId = id;
      this.getFormInfo(id);
      this.isCreate = 1;
    },
    // 编辑
    onEdit: function onEdit(id, obj) {
      var _this4 = this;
      var data = obj ? obj : this.editData;
      (0, _marketing.seckillUpdateApi)({
        id: id
      }, data).then(function (res) {
        _this4.isSuccess();
      }).catch(function (res) {
        _this4.listLoading = false;
      });
    },
    // 提交
    handlerSubmit: (0, _validate.Debounce)(function (formValue) {
      var _this5 = this;
      if (formValue.time.split(',')[0].split(':')[0] > formValue.time.split(',')[1].split(':')[0]) return this.$message.error('请填写正确的时间范围');
      this.isCreate === 0 ? (0, _marketing.seckillSaveApi)(formValue).then(function (res) {
        _this5.isSuccess();
      }) : (0, _marketing.seckillUpdateApi)({
        id: this.seckillId
      }, formValue).then(function (res) {
        _this5.isSuccess();
      });
    }),
    isSuccess: function isSuccess() {
      this.$message.success('操作成功');
      this.dialogVisible = false;
      this.getList();
    },
    // 列表
    getList: function getList(num) {
      var _this6 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      (0, _marketing.seckillListApi)(this.tableFrom).then(function (res) {
        _this6.tableData.data = res.list;
        _this6.tableData.total = res.total;
        _this6.tableData.data.map(function (item) {
          return _this6.$set(item, 'isEdit', false);
        });
        _this6.listLoading = false;
      }).catch(function (res) {
        _this6.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    add: function add() {
      this.isCreate = 0;
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.editData = {};
    }
  }
};